import { FC } from "react";
import { IconPropsType } from ".";

export const XMark: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.60666 0.588395L3.99978 2.98151L6.38892 0.592372C6.58558 0.395708 6.90908 0.390405 7.10575 0.587068L7.41201 0.893334C7.60867 1.09 7.60403 1.41416 7.40737 1.61083L5.01823 3.99996L7.41179 6.39352C7.60845 6.59018 7.60912 6.90905 7.41245 7.10571L7.10442 7.41374C6.90798 7.61019 6.58956 7.60864 6.39311 7.4122L3.99956 5.01864L1.6018 7.41639C1.40536 7.61284 1.08981 7.60886 0.893149 7.4122L0.586884 7.10593C0.39022 6.90927 0.386904 6.59438 0.583348 6.39794L2.9811 4.00018L0.587989 1.60707C0.391325 1.41041 0.389556 1.09177 0.586 0.895323L0.894033 0.58729C1.0907 0.390626 1.41 0.391731 1.60666 0.588395Z"
        fill={props.color}
      />
    </svg>
  );
};
